import { CALL_INTAKE_V2_API } from 'middleware/intakeV2Api';
import {
  GET_OPS_MANAGER_DASHBOARD_REQUEST,
  GET_OPS_MANAGER_DASHBOARD_SUCCESS,
  GET_OPS_MANAGER_DASHBOARD_FAILURE
} from './opsManagerDashboard.types';

// Get Operations Manager Dashboard Data
export const getOpsManagerDashboard = (filters) => ({
  [CALL_INTAKE_V2_API]: {
    types: [
      GET_OPS_MANAGER_DASHBOARD_REQUEST,
      GET_OPS_MANAGER_DASHBOARD_SUCCESS,
      GET_OPS_MANAGER_DASHBOARD_FAILURE,
    ],
    authenticated: true,
    endpoint: 'api/ops-manager/dashboard',
    method: 'POST',
    payload: {
      userIds: filters.selectedUserIds || [],
      clientId: filters.clientId || null,
      isVIP: filters.isVIP || null,
    },
  },
});